import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-05aad272")

_pushScopeId("data-v-05aad272")
const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "New User", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("User Listing")
const _hoisted_4 = /*#__PURE__*/_createVNode("h2", null, "User Information", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", null, "Login Credentials", -1)
const _hoisted_6 = { class: "buttons-container" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Create")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Cancel")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_el_button, {
        type: "info",
        icon: "el-icon-arrow-left",
        onClick: _ctx.routeToUsers
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"]),
      _withDirectives(_createVNode(_component_el_form, {
        model: _ctx.form,
        rules: _ctx.rules,
        ref: "formRef",
        "status-icon": "",
        "label-width": "150px"
      }, {
        default: _withId(() => [
          _hoisted_4,
          _createVNode(_component_el_form_item, {
            label: "First Name",
            prop: "first_name",
            required: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.first_name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.first_name = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Last Name",
            prop: "last_name",
            required: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.last_name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.last_name = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Email",
            prop: "email",
            required: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.email,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.email = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "User ID",
            prop: "user_id",
            required: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.user_id,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.user_id = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.isVAR)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "Organization",
                prop: "organizations_id",
                required: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.organizations_id,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.organizations_id = $event)),
                    class: "full-width",
                    filterable: "",
                    placeholder: "Select Organization"
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orgs, (org) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: org.id,
                          label: org.name,
                          value: org.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "Customer Admin",
            prop: "customer_admin",
            required: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.form.customer_admin,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.customer_admin = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _hoisted_5,
          _createVNode(_component_el_form_item, {
            label: "Phone Number",
            prop: "phone_number",
            required: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.phone_number,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.phone_number = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Password",
            prop: "password",
            required: !_ctx.isEditing
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.password,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.password = $event)),
                type: "password",
                "auto-complete": "off"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["required"]),
          _createVNode(_component_el_form_item, {
            label: "Password Confirm",
            prop: "password_confirm",
            required: !_ctx.isEditing
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.password_confirm,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.password_confirm = $event)),
                type: "password",
                "auto-complete": "off"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["required"]),
          _createVNode(_component_el_form_item, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_6, [
                (_ctx.isEditing)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _withDirectives(_createVNode(_component_el_button, {
                        onClick: _ctx.saveUser,
                        type: "primary"
                      }, {
                        default: _withId(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }, 8, ["onClick"]), [
                        [_directive_loading, _ctx.saveState === _ctx.FetchStates.FETCHING]
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_9, [
                      _withDirectives(_createVNode(_component_el_button, {
                        onClick: _ctx.saveUser,
                        type: "primary"
                      }, {
                        default: _withId(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }, 8, ["onClick"]), [
                        [_directive_loading, _ctx.saveState === _ctx.FetchStates.FETCHING]
                      ])
                    ])),
                _createVNode(_component_el_button, {
                  class: "cancel-button",
                  onClick: _ctx.routeToUsers
                }, {
                  default: _withId(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]), [
        [_directive_loading, _ctx.saveState === _ctx.FetchStates.FETCHING]
      ])
    ])
  ]))
})